module.exports = __webpack_public_path__ + "img/smart-home@2x.11ccabaf.jpg";